export const getGameList = state => state.game.gameList;
export const getGameDetails = state => state.game.gameDetails;
export const getGameStates = (state) => state.game.gameStates;
export const getGameState = (state, gameId) => getGameStates(state)[gameId];
export const getGameResults = state => state.game.gameResults;
export const getLeaderboardList = state => state.game.leaderboardList;
